import TotalMonthlyPriceWithFeeNotice from './TotalMonthlyPriceWithFeeNotice';

const TotalMonthlyPriceWithFee = ({ isOptInEligible = false, isRequired = false, notice = {} } = {}) => ({
  isOptInEligible: Boolean(isOptInEligible),
  isRequired: Boolean(isRequired),
  notice: TotalMonthlyPriceWithFeeNotice(notice),
});

export default TotalMonthlyPriceWithFee;

export type TotalMonthlyPriceWithFeeProps = ReturnType<typeof TotalMonthlyPriceWithFee>;
